const elderManage = {
    path: "/elderManage", //主体
    name: "elderManage",
    redirect: '/proManage',
    component: () =>
        import ("../views/elderManage/main"),
        children: [
            {
                path: "/proManage", //项目管理
                name: "proManage",
                mate: {
                    title: '项目管理'
                },
                component: () =>
                    import ("../views/elderManage/proManage/index")
            },
            {
                path: "/elderInfo", //老人信息
                name: "elderInfo",
                mate: {
                    title: '老人信息'
                },
                component: () =>
                    import ("../views/elderManage/elderInfo/index")
            },
            {
                path: "/serviceManage", //服务商管理
                name: "serviceManage",
                component: () =>
                    import ("../views/elderManage/serviceManage/index"),
                mate: {
                    title: '服务商管理'
                },
                children: [{
                        path: '/standard',
                        name: 'standard',
                        component: () =>
                            import ("../views/elderManage/serviceManage/standard"),
                        mate: {
                            title: '验收标准'
                        }
                    },
                    {
                        path: '/settlement',
                        name: 'settlement',
                        component: () =>
                            import ("../views/elderManage/serviceManage/settlement"),
                        mate: {
                            title: '结算管理'
                        },
                    },
                    {
                        path: '/service',
                        name: 'service',
                        component: () =>
                            import ("../views/elderManage/serviceManage/service"),
                        mate: {
                            title: '服务商信息'
                        },
                    }
                ]
            },
            {
                path: "/personnelInfo", //人员信息
                name: "personnelInfo",
                component: () =>
                    import ("../views/elderManage/personnelInfo/index"),
                mate: {
                    title: '人员信息'
                },
            },
            {
                path: "/servicesPerson", //服务人员
                name: "servicesPerson",
                component: () =>
                    import ("../views/elderManage/servicesPerson/index"),
                mate: {
                    title: '服务人员'
                },
            },
            {
                path: "/elderApply", //适老化申请
                name: "elderApply",
                component: () =>
                    import ("../views/elderManage/elderApply/index"),
                mate: {
                    title: '适老化申请'
                },
                redirect: '/elderApplyPage',
                children: [{
                        path: "/elderApplyPage", //老人申请
                        name: "elderApplyPage",
                        component: () =>
                            import ("../views/elderManage/elderApply/elderApplyPage"),
                        mate: {
                            title: '老人申请'
                        }
                    },
                    {
                        path: "/cdoeManage", //二维码管理
                        name: "cdoeManage",
                        component: () =>
                            import ("../views/elderManage/elderApply/codeManage"),
                        mate: {
                            title: '二维码管理'
                        }
                    }
                ]
            },
            // {
            //   path: "/dictionaries", //数字字典
            //   name: "dictionaries",
            //   component: () => import ("../views/elderManage/dictionaries/index"),
            //   mate: {
            //       title: '数字字典'
            //   },
            //   redirect: '/AddressManagement',
            //   children: [
            //     {
            //         path: "/AddressManagement", //老人申请
            //           ame: "AddressManagement",
            //           component: () =>
            //               import ("../views/elderManage/dictionaries/AddressManagement"),
            //           mate: {
            //               title: '地址管理'
            //           }
            //       },
            //     {
            //         path: "/productManage", //老人申请
            //         name: "productManage",
            //         component: () =>
            //             import ("../views/elderManage/dictionaries/productManage"),
            //         mate: {
            //             title: '产品管理'
            //         }
            //     },
            //     {
            //         path: "/dictionaries", //数字字典
            //         name: "dictionaries",
            //         component: () =>
            //             import ("../views/elderManage/dictionaries/dictionaries"),
            //         mate: {
            //             title: '数字字典'
            //         }
            //     }
            //   ]
            // },
        ]
}

export default elderManage